import DOMPurify from 'dompurify';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getTerms } from '../../api/util';
import '../../css/Policy.css';
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation';
import { OrderInfoCont } from '../../pages/myshopping/OrderRefund';
import { imgURL } from '../Footer';

interface PropsType {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  isModal: boolean;
}

/**
 * 모달 팝업 - 전체 화면
 *
 * @params {React.ReactNode} content - 콘텐츠 내용
 * @params {string} headerText - 모달 헤더 제목
 */

export default function RefundNotice({ setIsModal, isModal }: PropsType) {
  const [closing, setClosing] = useState<boolean>(false); // 닫힘 애니메이션 적용에 필요
  const [item, setItem] = useState<string>('');
  useEffect(() => {
    getTerms('WITHDRAWAL_GUIDE').then((res) => {
      setItem(res.data.withdrawal_guide.contents);
    });
  }, []);

  const closeModal = () => {
    setClosing(true);

    setTimeout(() => {
      setIsModal(false);
      setClosing(false);
    }, 280);
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  if (!isModal) return null;
  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <button onClick={closeModal} className="btn_close">
            <img src={`${imgURL}/icon_close.png`} alt="닫기" />
          </button>
        </ModalHeader>
        <ModalBody>
          {/* 반품 안내 */}
          <OrderInfoCont className="refund_cont">
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }}></div>
          </OrderInfoCont>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  );
}

interface typeProps {
  closing?: boolean;
}

export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: var(--colBlack);
  opacity: 0.6;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`;

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 20;
`;
export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0 4px 0 20px;
  & button.btn_close {
    background: none;
    border: none;
    width: 48px;
    height: 48px;
    padding: 12px;
    & img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const ModalBox = styled.div<typeProps>`
  width: 100%;
  height: 100%;
  background-color: var(--colWhite);
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: fixed;
  z-index: 30;
  display: flex;
  flex-direction: column;
`;

export const ModalBody = styled.div`
  overflow-y: auto;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;
